// extracted by mini-css-extract-plugin
export default {"container":"LSEForm_container__IuMxl","link":"LSEForm_link__Znq8I"};